// parallax-decoration.js
(() => {
    const mqDesktop = window.matchMedia('(min-width: 1024px)'); // dostosuj do var.$desktop
    const mqReduce  = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mqReduce.matches) return;

    const icons = Array.from(document.querySelectorAll('.decoration .decoration-icon'));
    if (!icons.length) return;

    const active = new Set(); // elementy aktualnie widoczne

    const getRange = (root) => {
        const cssVar = parseFloat(getComputedStyle(root).getPropertyValue('--parallax-range')) || 240;
        // opcjonalnie skaluj zakresem wysokości sekcji:
        return Math.min(cssVar, Math.max(120, root.clientHeight * 0.35));
    };

    const calcY = (root, speed = 1) => {
        const r = root.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        // pozycja środka sekcji -> -1..1 względem środka viewportu
        const center = r.top + r.height / 2;
        const norm = (center - vh / 2) / (vh / 2 + r.height / 2); // -1 (nad) ... 0 ... 1 (pod)
        const clamped = Math.max(-1, Math.min(1, norm));

        const range = getRange(root);
        return -clamped * range * speed; // minus = przesuw w przeciwną stronę dla fajniejszego efektu
    };

    const setY = (el, y) => el.style.setProperty('--parallax-y', `${y.toFixed(2)}px`);

    let ticking = false;
    const rafUpdate = () => {
        ticking = false;
        if (!mqDesktop.matches) { // mobilki – reset
            active.forEach(el => setY(el, 0));
            return;
        }
        active.forEach(el => {
            const root  = el.closest('.decoration') || document.body;
            const speed = parseFloat(el.dataset.speed || '0.6'); // możesz sterować data-speed na elemencie
            setY(el, calcY(root, speed));
        });
    };

    const requestTick = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(rafUpdate);
        }
    };

    // IntersectionObserver – aktualizujemy tylko widoczne
    const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const el = entry.target;
            if (entry.isIntersecting) {
                active.add(el);
                requestTick();
            } else {
                active.delete(el);
                setY(el, 0); // gdy znika – reset
            }
        });
    }, { root: null, threshold: [0, 0.01, 1] });

    icons.forEach(el => io.observe(el));

    // scroll/resize
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    mqDesktop.addEventListener?.('change', requestTick);

    // pierwszy przeliczek
    requestTick();
})();

// counter
(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Easing: easeOutCubic
    const easeOut = t => 1 - Math.pow(1 - t, 3);

    function animateCount(el, to, {duration = 1200, once = true} = {}) {
        if (el.dataset.counted && once) return;

        // Bez animacji przy reduced motion
        if (prefersReduced || duration <= 0) {
            el.textContent = formatNumber(to);
            el.dataset.counted = '1';
            return;
        }

        const start = 0;
        const startTs = performance.now();

        function frame(now) {
            const t = Math.min((now - startTs) / duration, 1);
            const val = Math.round(start + (to - start) * easeOut(t));
            el.textContent = formatNumber(val);

            if (t < 1) requestAnimationFrame(frame);
            else el.dataset.counted = '1';
        }

        requestAnimationFrame(frame);
    }

    function formatNumber(n) {
        // prosty formatter bez spacji tysięcznych (możesz podmienić na locale pl-PL)
        return n.toString();
        // lub: return n.toLocaleString('pl-PL');
    }

    function setupObserver() {
        const cards = document.querySelectorAll('.fact-card');
        if (!cards.length) return;

        const io = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const counts = entry.target.querySelectorAll('.count[data-count]');
                counts.forEach(c => {
                    const to = Number(c.getAttribute('data-count')) || 0;
                    animateCount(c, to, { duration: 1400, once: true });
                });

                // Jeśli licznik uruchomiony, możesz przestać obserwować kartę
                io.unobserve(entry.target);
            });
        }, { threshold: 0.5 }); // ~50% karty w kadrze

        cards.forEach(c => io.observe(c));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupObserver);
    } else {
        setupObserver();
    }
})();
